<template>
  <div>
    <v-menu ref="menuDate" v-model="menuDate" :nudge-right="40"
            transition="scale-transition" lazy offset-y full-width min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field v-model="dateFormatted" :disabled="disabled" :label="label"
                      append-icon="event" readonly class="pt-0 mt-0" hide-details v-on="on"
        />
      </template>
      <v-date-picker v-model="date" :max="maxValue" :min="minValue" :readonly="disabled"
                     no-title scrollable first-day-of-week="1" locale="es"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'VDate',
  props: {
    value: {
      type: [Date, String, Number, Object],
      default: Date.now()
    },
    label: { type: String, default: '' },
    max: { type: [Date, String, Number, Object], default: null },
    min: { type: [Date, String, Number, Object], default: null },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      menuDate: false,
      date: null,
      dateFormatted: null,
      maxValue: null,
      minValue: null
    }
  },
  watch: {
    value (value) {
      if (value) {
        this.date = moment(this.value).format('YYYY-MM-DD')
        this.dateFormatted = moment(this.value).format('DD/MM/YYYY')
      } else {
        this.date = null
        this.dateFormatted = null
      }
    },
    date (value) {
      let newDate = moment(value, 'YYYY-MM-DD')
      this.dateFormatted = newDate.format('DD/MM/YYYY')
      this.$emit('input', newDate.valueOf())
    },
    max (value) {
      this.maxValue = moment(value).format('YYYY-MM-DD')
    },
    min (value) {
      this.minValue = moment(value).format('YYYY-MM-DD')
    }
  },
  mounted () {
    this.date = moment(this.value).format('YYYY-MM-DD')
    this.dateFormatted = moment(this.value).format('DD/MM/YYYY')
  }
}
</script>
